<template>
  <el-card>
    <header slot="header">
      <h2>Manage Users</h2>
    </header>

    <section>
      <el-table v-loading="loading" :data="filteredUsers" style="width: 100%;">
        <el-table-column
            label="Name"
            prop="name">
        </el-table-column>
        <el-table-column
            label="Email"
            prop="email">
        </el-table-column>
        <el-table-column
            align="right">
          <template slot="header" slot-scope="scope">
            <el-input
                clearable
                v-model="search"
                size="mini"
                placeholder="Search"/>
          </template>
          <template slot-scope="scope">
            <el-button
                v-if="hasPermissionsTo(['manage-access'])"
                plain
                type="primary"
                size="mini"
                @click="handleAccess(scope.row)">Access
            </el-button>
            <el-button
                v-if="hasPermissionsTo(['manage-thresholds'])"
                plain
                type="primary"
                size="mini"
                @click="handleThresholds(scope.row)">Thresholds
            </el-button>
            <el-popconfirm
                v-if="hasPermissionsTo(['delete-users'])"
                :title="`Are you sure to delete ${scope.row.name || scope.row.email}?`"
                confirmButtonText="Delete"
                cancelButtonText="Cancel"
                icon="el-icon-info"
                iconColor="red"
                @confirm="handleDelete(scope.row)">
              <el-button
                  plain
                  slot="reference"
                  size="mini"
                  icon="el-icon-delete"/>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </el-card>
</template>

<script>
import {mapGetters} from 'vuex';
import axios, {RepositoryError} from '../../repositories';
import {notify} from '../../utils';

export default {
  name: 'ManageUsers',
  data() {
    return {
      search: '',
      users: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["hasPermissionsTo"]),
    filteredUsers() {
      return this.users.filter(u => (
          !this.search ||
          (
              u.name.toLowerCase().includes(this.search.toLowerCase()) ||
              u.email.toLowerCase().includes(this.search.toLowerCase())
          )
      ));
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;
        const response = await axios.get('/users');

        this.users = response.data;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      } finally {
        this.loading = false;
      }
    },
    handleAccess(user) {
      this.$router.push(`/users/${user.id}`);
    },
    handleThresholds(user) {
      this.$router.push(`/users/${user.id}/thresholds`);
    },
    async handleDelete(user) {
      try {
        this.loading = true;
        await axios.delete(`/users/${user.id}`);
        notify(`Deleted user ${user.name || user.email}`, 'success');
        const index = this.users.findIndex(u => u.id === user.id);
        this.users.splice(index, 1);
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
